<template>
  <Modal v-model="orderAmountModificationModal" :title="$t('key1004638')" class-name="commonModalStyles"
    :transfer="false" :mask-closable="false" width="500">
    <Form ref="orderAmountModificationForm" :label-width="100" @submit.native.prevent>
      <h2 class="font-size-12 mb12 ml20">{{ $t('key1004639') }}</h2>
      <Row style="width: 80%;">
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-for="item in packageGoodsList">
          <FormItem class="reset_label">
            <template slot="label">
              <Tooltip max-width="500" placement="top" transfer>
                <div slot="content">
                  <p>{{ item.name }}</p>
                  <p class="mt2">{{ item.variations }}</p>
                </div>
                <p class="flex align-items-center">
                  <span class="wid100P ellipsis_1">{{ item.name }}</span>
                  <span>：</span>
                </p>
                <p class="flex align-items-center mt3">
                  <span class="wid100P font-size-12 color-999 ellipsis_1">{{ item.variations }}</span>
                  <span>：</span>
                </p>
              </Tooltip>
            </template>
            <div class="flex align-items-center">
              <InputNumber
                class="width_200"
                :min="0"
                :max="999999999"
                :formatter="(value) => formatterNumber(value, 2)"
                @on-blur="calculateTheTotalAmount"
                v-model="item.productGoodsCost"/>
              <span class="ml5 mr5">{{ currencyState }}</span>
              <span>{{ '*' + ' ' + item.quantity }}</span>
            </div>
          </FormItem>
        </Col>
        <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol" v-for="item in packageCostsList">
          <FormItem :label="item.name">
            <div class="flex align-items-center">
              <InputNumber
                class="width_200"
                :min="0"
                :max="999999999"
                :formatter="(value) => formatterNumber(value, 2)"
                @on-blur="calculateTheTotalAmount"
                v-model="item.amount"/>
              <span class="ml5 mr5">{{ currencyState }}</span>
            </div>
          </FormItem>
        </Col>
      </Row>
      <div class="wid100P text-align-right mt30 mb10">{{ $t('key1000118') + totalOrderAmount + ' ' + currencyState }}</div>
    </Form>
    <template #footer>
      <Button @click="orderAmountModificationModal = false">{{ $t('key1000112') }}</Button>
      <Button type="primary" @click="orderAmountModificationBtn">{{ $t('key1000111') }}</Button>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {amountHandel, formatterNumber} from "@/utils/common";

export default {
  name: 'orderAmountModificationModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      orderAmountModificationModal: false,
      packageCostsList: [
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000297'), type: 2, amount: null},
        {name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000298'), type: 4, amount: null},
      ],
      packageGoodsList: [],
      totalOrderAmount: 0,
      ymsPackageId: null,
    };
  },
  computed: {},
  created() {

  },
  methods: {
    // 初始化数据
    initOrderAmountModificationData(obj) {
      this.ymsPackageId = obj.ymsPackageId;
      let ymsPackageGoods = obj.ymsPackageGoods || [];
      let ymsPackageCosts = obj.ymsPackageCosts || [];
      this.packageGoodsList = ymsPackageGoods.map((item) => {
        return {
          name: item.name,
          ymsPackageGoodsId: item.ymsPackageGoodsId,
          productGoodsCost: item.productGoodsCost,
          variations: item.variations,
          quantity: item.quantity,
        };
      });

      function sumNumByType(arr) {
        const result = {};
        for (let i = 0; i < arr.length; i++) {
          const obj = arr[i];
          const type = obj.type;
          const amount = obj.amount;

          if (type in result) {
            result[type] += amount;
          } else {
            result[type] = amount;
          }
        }
        return result;
      }

      let costsObj = sumNumByType(ymsPackageCosts);
      this.packageCostsList.forEach((ele) => {
        ele.amount = costsObj[ele.type] || 0;
      });
      this.calculateTheTotalAmount();
      this.orderAmountModificationModal = true;
    },
    formatterNumber,
    // 确定按钮
    orderAmountModificationBtn() {
      let query = {
        updatePackageCosts: [],
        updatePackageGoods: [],
        ymsPackageId: this.ymsPackageId
      };
      query.updatePackageCosts = this.packageCostsList.map((item) => {
        return {
          type: item.type,
          amount: item.amount
        };
      });
      query.updatePackageGoods = this.packageGoodsList.map((item) => {
        return {
          ymsPackageGoodsId: item.ymsPackageGoodsId,
          productGoodsCost: item.productGoodsCost
        };
      });
      this.axios.post(api.post_ymsPackageInfo_updatePackagePrice, query,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then((response) => {
        if (response.data.code === 0) {
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002161'));
          this.orderAmountModificationModal = false;
          this.$emit('updateData', true);
        }
      });
    },
    // 计算总金额
    calculateTheTotalAmount() {
      function sumAmounts(amounts) {
        return amounts.reduce((total, item) => total + (item || 0), 0);
      }

      const costsTotal = sumAmounts(this.packageCostsList.map(item => item.amount));
      const goodsTotal = sumAmounts(this.packageGoodsList.map(item => item.productGoodsCost * item.quantity));
      this.totalOrderAmount = amountHandel(costsTotal + goodsTotal);
    }
  },
};
</script>

<style lang="less">
.commonModalStyles .reset_label {
  label {
    padding: 3px 0 0 0;
  }
}
</style>
